"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const AVATAR_SIZES = {
    xlarge: { width: "3rem", fontSize: "1.25rem" },
    large: {
        width: "2.5rem",
        fontSize: "1rem",
    },
    medium: { width: "2rem", fontSize: "0.875rem" },
    small: { width: "1.5rem", fontSize: "0.875rem" },
};
const AVATAR_COLORS = {
    blue: {
        background: "var(--ds-color-blue-25)",
        border: "var(--ds-color-blue-50)",
    },
    greyscale: {
        background: "var(--ds-color-dishwater)",
        border: "var(--ds-color-silver)",
    },
    white: {
        background: "var(--ds-color-white)",
        border: "var(--ds-color-silver)",
    },
};
exports.StyledAvatar = styled_components_1.default.span `
    font-family: "Roboto", sans-serif;
    font-size: ${({ $size }) => AVATAR_SIZES[$size].fontSize};
    font-weight: bold;
    border-radius: var(--ds-border-radius);
    background-color: ${({ $color }) => AVATAR_COLORS[$color].background};
    border: 1px solid ${({ $color }) => AVATAR_COLORS[$color].border};
    color: var(--ds-color-night);
    aspect-ratio: 1 / 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${({ $size }) => AVATAR_SIZES[$size].width};
    height: ${({ $size }) => AVATAR_SIZES[$size].width};
`;
//# sourceMappingURL=Avatar.styles.js.map